import { render } from "./ongoing-coaches-modal.vue?vue&type=template&id=6f3bb968"
import script from "./ongoing-coaches-modal.vue?vue&type=script&lang=js"
export * from "./ongoing-coaches-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__